<template>
    <main-layout>

        <app-header icon="tool">
            Ajout outillage
        </app-header>

        <action-bar :back="{name: 'liste-outils'}">
        </action-bar>

        <form class="wrap" @submit.prevent="onSubmit">

            <label>Type d'outillage *</label>
            <select name="type" id="type-outil" v-model="outil.type_outil">
                <option selected disabled>Sélectionnez un type d'outil</option>
                <option v-for="typeOutil in types" :key="typeOutil.id" :value="typeOutil">{{ typeOutil.nom }}</option>
            </select>

            <label>Marque *</label>
            <input title="mark" type="text" name="marque" id="marque" v-model.trim="outil.marque" maxlength="255">

            <label>Modèle *</label>
            <input title="model" type="text" name="nom_appareil" id="nom_appareil" v-model.trim="outil.modele" maxlength="255">

            <label>N° de série / repère *</label>
            <input title="idNumber" type="text" name="num_serie" id="num_serie" v-model.trim="outil.numero_serie" maxlength="255">

            <label>Distributeur</label>
            <input title="dist" type="text" name="fournisseur" id="fournisseur" v-model.trim="outil.magasin" maxlength="255">

            <label>Date d'achat</label>
            <input title="buyDate" type="date" name="date_achat" id="date_achat" :max="now" v-model="outil.date_achat" @change="setDateAchat($event)">

            <label>N°facture</label>
            <input title="invoiceNumber" type="text" name="facture_achat" id="facture_achat" v-model.trim="outil.facture_achat" maxlength="255">

            <label>N°bon de livraison</label>
            <input title="deliveryNumber" type="text" name="bon_livraison" id="bon_livraison" v-model.trim="outil.bon_livraison" maxlength="255">

            <label>Dernier contrôle *</label>
            <input title="lastControl" type="date" name="last_controle" id="last_controle" :max="now" v-model="outil.date_last_controle" @change="setDateLastControl($event)">

            <input type="submit" id="submit-outil" name="save" value="AJOUTER" :disabled="saving">

        </form>

    </main-layout>
</template>

<script>

    import Outil from '../../js/models/Outil'

    export default {

        data() {
            return {
                outil: {
                    type_outil: null,
                    marque: null,
                    modele: null,
                    numero_serie: null,
                    reference: null,
                    magasin: null,
                    date_achat: null,
                    facture_achat: null,
                    bon_livraison: null,
                    date_last_controle: null,
                    actif: true,
                },
                types: [],
                saving: false
            }
        },

        methods: {
            async onSubmit() {
                if (this.saving) {
                    return;
                }

                let outil = this.$data.outil;
                let errors = [];

                if(!outil.type_outil){
                    errors.push("le type d'outil")
                }

                if(!outil.marque){
                    errors.push("la marque")
                }

                if(!outil.modele){
                    errors.push("le modèle")
                }

                if(!outil.numero_serie){
                    errors.push("le numéro de série")
                }

                if(!outil.date_last_controle || outil.date_last_controle === 'Invalid date'){
                    errors.push("la date du dernier contrôle")
                }

                if(outil.date_achat === 'Invalid date'){
                    outil.date_achat = null;
                }

                if(errors.length !== 0){
                    let txt = errors.join(', ');
                    swal('Information(s) manquante(s) :', 'Veuillez renseigner '+txt+'.', 'error')
                } else {
                    this.saving = true;
                    try {
                        await Outil.addOutilOffline(Object.assign({}, outil));
                    } catch (e) {
                        this.saving = false;
                        swal('Erreur', "L'outil n'a pas pu être enregistré", 'error');
                        return;
                    }

                    this.$router.push('liste-outils');
                    swal('Outil ajouté', 'Votre outillage a bien été ajouté et activé', 'success')
                }
            },

            fetchTypes() {
                Outil.getTypes().then(data => this.types = _.sortBy(data, ['nom'])).catch()
            },

            setDateAchat(event) {
                const inputValue = event.target.value;
                this.outil.date_achat = inputValue;
            },
            setDateLastControl(event) {
                const inputValue = event.target.value;
                this.outil.date_last_controle = inputValue;
            }

        },

        mounted() {

            this.fetchTypes()

        },

        computed: {
            now: function () {
                return moment().format('Y-MM-DD')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// NewOutil.vue?cc21e90e